"use client";

import { cn } from "@/lib/utils";
import type { ImageDetails } from "@/types";
import Image from "next/image";
import Link from "next/link";
import { ActionButton, type ActionButtonProps } from "./ActionButton";
import { AdaptiveText, type AdaptiveTextProps } from "./Content";
import { Title } from "./Content/Title";
import { Sizes } from "./Content/styles";
import { Gradient } from "./Gradient";

type Props = {
	title: string;
	text: AdaptiveTextProps["portableText"];
	image: ImageDetails;
	action: ActionButtonProps;
	className?: string;
	as?: React.ElementType;
};

export const RadiantCard = ({
	title,
	text,
	image,
	action,
	className,
	as = "div",
}: Props) => {
	const Component = as || "div";

	return (
		// @ts-ignore - // TODO: fix this
		<Component
			// @ts-ignore - // TODO: fix this
			className={cn(
				"group/parent relative isolate flex flex-col overflow-hidden rounded-lg p-6",
				className,
			)}
		>
			<div className="flex-1">
				<Gradient className="-z-10 absolute inset-0 rounded-lg" />
				<div className="-z-10 absolute inset-px rounded-lg bg-white/90" />
				<Image
					src={image.src}
					alt={image.alt}
					width={1920}
					height={1080}
					className="aspect-video max-h-[200px] w-full rounded-lg border border-primary/70 object-cover"
				/>
				<Link href={action.href}>
					<span className="absolute inset-0" />
					<Title as="h3" size={Sizes.Card} className="mt-6 sm:mt-12">
						{title}
					</Title>
				</Link>

				<AdaptiveText portableText={text} size={Sizes.Card} />
			</div>

			<ActionButton {...action} respondToParentHover={true} className="mt-8" />
		</Component>
	);
};
